<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-text" style="width: 100%">
        <mat-form-field style="width: 100%">
          <mat-label> {{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component"
            (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateStaticData();"></textarea>
        </mat-form-field>
      </div>

      <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
      [staticdata]="staticdata" [textContentClass]="class['button__content']" [textWrapperClass]="class['button']"
      (changeTextAlignConfig)="changeWidthHeight({width: width})">
      </app-text-format-config>
  
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>
  <!-- Cấu hình nâng cao -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'" >
    <ul nz-menu nzMode="inline">
      <!-- Cấu hình thông số cơ bản của button-->
      <li
        nz-submenu
        nzTitle="{{'hien_thi'| translate}}"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình format font name của button -->
      <li
        nz-submenu
        nzTitle="{{'dinh_dang_ten_nut' | translate}}"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')"
      >
        <div class="container-font">
          <!-- chọn ngôn ngữ đa ngôn ngữ -->
          <div class="mb-3">
            
          </div>
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea
                matInput
                [ngModel]="staticdata['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                (ngModelChange)="staticdata['content_' + functionService.selectedLanguageCode] = $event"  
                (blur)="updateStaticData()"
              ></textarea>
            </mat-form-field>
          </div>
          <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
            [staticdata]="staticdata" [textContentClass]="class['button__content']" [textWrapperClass]="class['button']"
            (changeTextAlignConfig)="changeWidthHeight({width: width})">
          </app-text-format-config>
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLetterSpacing]="class['button__content']" (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classLineHeight]="class['button__content']" (updateClass)="updateClass()">
          </app-line-height-config>
          <!-- Khoảng đệm bên trái của chữ -->
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
            [classPadding]="class['button__content']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
          </app-padding-config>
          <label class="px-1">{{'gian_cach' | translate}}</label>
          <div class="padding">
            <div class="d-flex items justify-content-between">
              <img src="./assets/root/images/system/icons/padding-right-left.svg" alt="padding" width="30px" />
              <nz-input-number [nzMin]="0" [nzMax]="200" style="max-width: 50%" [nzStep]="1"
                [(ngModel)]="config['padding']" (nzBlur)="updateConfig(); changeWidthHeight({width: width})">
              </nz-input-number>
            </div>
          </div>
        </div>
      </li>
      <!-- Cấu hình màu nền của button -->
      <li
        nz-submenu
        nzTitle="{{'mau_sac' | translate}}"
        [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <div class="container-color">
          <button
            id="btn-color"
            *ngFor="let background of backgroundColor; let i = index"
            [ngStyle]="{ 'background-color': background.bgColor }"
            (click)="chooseBg(background, $event)"
            nz-tooltip
            [disabled]="config['background-color'].gradient_check"
          ></button>
        </div>
        <div class="color-pick">
          <span class="title w-50">Chọn màu</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
            [style.background]="class['button']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
            [cpPositionRelativeToArrow]="true"
          />
        </div>
        <div
          class="mr-2 mb-4 mt-4 view-more"
          style="
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 7px;
          "
        >
          <p
            class="discover_text"
            (click)="openViewAll(styles_field[3])"
            style="cursor: pointer; text-align: left; margin: 0"
          >
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li
        nz-submenu
        nzTitle="{{'do_bong' | translate}}"
        [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')"
      >
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['button']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li
        nz-submenu
        nzTitle="{{'kieu_vien' | translate}}"
        [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')"
      >
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
          [borderClass]="class['button']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p
            class="m-0 title-border my-2"
            (click)="openViewAll(styles_field[1])"
          >
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <!-- Cấu hình biểu tượng -->
      <li
        nz-submenu
        nzTitle="{{'bieu_tuong' | translate}}"
        [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')"
      >
        <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['button']"
          [fontSizeIconClass]="class['button__content--icon-wrapper']" [symbolConfig]="config['flex-direction']"
          [objectChoosing]="objectChoosing">
        </app-symbol-config>

        <ng-container *ngIf="config?.['flex-direction']?.['icon_disable']">
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMapSub.submenu1"
          (nzOpenChange)="openHandler('submenu1', true)">
            <!-- Khoảng đệm của khung chứa biểu tượng -->
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['button__content--icon-wrapper']" [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
          </li>
          <li nz-submenu nzTitle="{{'vien' | translate}}" [(nzOpen)]="openMapSub.submenu2"
          (nzOpenChange)="openHandler('submenu2', true)">
            <!-- Viền của biểu tượng -->
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['button__content--icon-wrapper']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[4])">
                {{'bo_goc' | translate}} &#8594;
              </p>
            </div>
          </li>
        </ng-container>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li
        nz-submenu
        nzTitle="{{'hieu_ung' | translate}}"
        [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')"
      >
        <app-choose-animations-config [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)" [id_object]="objectChoosing._id" [device]="device"
          [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['button']"
          [effect_hover]="effect_hover" [customize]="customize" [effectFileUsing]="'button'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['button']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config
        [staticdata]="staticdata"
        [id_object]="objectChoosing._id"
        [customize]="customize"
        [device]="device"
      ></app-animations-config>
    </div>
    <!-- Cấu hình chi tiết màu gradient  -->
    <div class="container-gradient" *ngIf="currentViewAll.index == 4">
      <div class="title-head">
        <p class="text-fill">{{'phoi_mau' | translate}}</p>
        <label
          nz-checkbox
          [(ngModel)]="config['background-color'].gradient_check"
          (ngModelChange)="updateBackgroundRgb()"
        ></label>
      </div>
      <div class="list-gradient">
        <button
          class="btn-gradient"
          *ngFor="
            let bgGradient of config['background-color']['gradient_arr'];
            let i = index
          "
          (click)="deleteGradient(i)"
          [ngStyle]="{ 'background-color': bgGradient }"
          [disabled]="!config['background-color'].gradient_check"
        >
          <i class="delete-icon bi bi-x-circle"></i>
        </button>
      </div>
      <p class="title-head">{{ 'them_mau' | translate }}</p>
      <div class="container_add-gradient">
        <input
          class="input-color"
          [cpOKButton]="true" [(colorPicker)]="class['button']['background-color']"
          type="button"
          [disabled]="!config['background-color'].gradient_check"
          [style.background]="class['button']['background-color']"
          (colorPickerClose)="addGradient($event)"
        />
      </div>
      <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
      <button
        class="gradient-direction"
        *ngFor="let type of functionService.gradientDirectionList"
        nz-tooltip
        [nzTooltipTitle]="type.name"
        (click)="chooseOption(type, $event)"
        [disabled]="!config['background-color'].gradient_check"
        [style.background]="
          'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'
        "
        [class.active]="config['background-color'].gradient_direction === type.direction"
      ></button>
    </div>
  </div>
</div>